module.exports = __webpack_public_path__ + "static/img/img_no_data.03ee8dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_no_data.png
// module id = pGpd
// module chunks = 1